import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import UpdateListingPreview from '../../components/Proposal/UpdateListing/Preview/UpdateListingPreview'
import WithProposalContainer from '../Common/WithProposalContainer'

UpdateListingPreview.fetchData = async ({ store, req, res, match }) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const props = {
  proposalType: PROPOSAL_TYPE.UPDATE_LISTING
}

const MappedContainer = WithProposalContainer(UpdateListingPreview, props)

export default MappedContainer
